import React, { createContext, useContext } from 'react';
import { Node } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { QrCode, GripVertical } from 'lucide-react';

export const FirmaImgsContext = createContext({ layout: null, selloSrc: null, firmaSrc: null });

const Pieza = ({ c, size, children }) => (
  <div className="fb-img" style={{ left: `${c.x}mm`, top: `${c.y}mm`, width: `${size}mm`, height: `${size}mm` }}>{children}</div>
);

const FirmaBloqueView = ({ selected }) => {
  const { layout, selloSrc, firmaSrc } = useContext(FirmaImgsContext);
  const B = layout.bloque;
  return (
    <NodeViewWrapper className={`nota-firma-bloque group ${selected ? 'outline outline-2 outline-violet-500' : 'outline-dashed outline-1 outline-violet-300'}`}
      data-firma-bloque="" data-testid="nota-firma-bloque" contentEditable={false}>
      <div data-drag-handle className="absolute -left-6 top-1 cursor-grab text-violet-400 opacity-0 group-hover:opacity-100" title="Arrastrar">
        <GripVertical className="w-4 h-4" />
      </div>
      <Pieza c={B.sello} size={B.sello.max}>{selloSrc ? <img src={selloSrc} alt="Sello" /> : <span className="text-[10px] text-gray-400">Sello</span>}</Pieza>
      <Pieza c={B.firma} size={B.firma.max}>{firmaSrc ? <img src={firmaSrc} alt="Firma" /> : <span className="text-[10px] text-gray-400">Elegí quién firma</span>}</Pieza>
      <Pieza c={B.qr} size={B.qr.size}><div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400"><QrCode className="w-6 h-6" /></div></Pieza>
    </NodeViewWrapper>
  );
};

export const FirmaBloque = Node.create({
  name: 'firmaBloque',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,
  parseHTML: () => [{ tag: 'div[data-firma-bloque]' }],
  renderHTML: () => ['div', { 'data-firma-bloque': '' }],
  addNodeView: () => ReactNodeViewRenderer(FirmaBloqueView),
  addCommands() {
    return {
      insertarFirma: () => ({ tr, state, dispatch }) => {
        const tipo = state.schema.nodes.firmaBloque;
        const { $to } = state.selection;
        let destino = $to.depth ? $to.after(1) : state.selection.to;
        const existentes = [];
        state.doc.descendants((n, pos) => { if (n.type === tipo) existentes.push(pos); });
        if (dispatch) {
          existentes.reverse().forEach(pos => tr.delete(pos, pos + 1));
          destino = tr.mapping.map(destino);
          tr.insert(destino, tipo.create());
        }
        return true;
      },
    };
  },
});
